module.exports = __webpack_public_path__ + "static/tele_notes-57290d799e74fa7925ddb8d9a01577f2.jpg";